import styled from "styled-components";

export const Logo = styled.h1`
  color: #6099ff;
  font-size: 1.4rem;
`;
export const LogoImage = styled.img`
  margin: 0 -0.4rem 0 0;
`;
